import { render, staticRenderFns } from "./SgmCertificateDetail.vue?vue&type=template&id=fd654e12&scoped=true"
import script from "./SgmCertificateDetail.vue?vue&type=script&lang=js"
export * from "./SgmCertificateDetail.vue?vue&type=script&lang=js"
import style0 from "./SgmCertificateDetail.vue?vue&type=style&index=0&id=fd654e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd654e12",
  null
  
)

export default component.exports